import React, { useEffect, useMemo, useState } from "react";
import Layout from "../../../components/Layout";
import BlackWhiteButton from "../../../components/buttons/BlackWhiteButton";
import AddButton from "../../../components/buttons/AddButton";

import {
  List,
  ListHeader,
  ListHeaderItem,
  ListHeaderItemDropdown,
  ListBody,
  ListBodyCell,
  ListBodyItem,
  ListBodyItemSelect,
  ListBodyItemNumberformat,
} from "../../../components/_widgets/WidgetsList";
import moment from "moment-timezone";
import api from "../../../config/api";
import { getUserEstablishment, getClientReservationsAllByEstablishment } from "../../../config/utils";
import { ConfirmDelete } from "../../../components/Alert";
import ReservePetDrawer from "./components/Pet/ReservePetDrawer";
import ReserveFashionDrawer from "./components/Fashion/ReserveFashionDrawer";
import ReserveFoodDrawer from "./components/Food/ReserveFoodDrawer";
import { useAuth } from "../../../context/ContextApi";
import NewReserveFoodDrawer from "./components/Food/NewReserveFoodDrawer";
import EmptyListContent from "../Product/components/List/EmptyListContent";

import NewReservePetDrawer from "./components/Pet/NewReservePetDrawer";
import { parseISO } from "date-fns";
import swal from "sweetalert";
import { useLocation, useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";

require("dotenv").config();

function Reserve() {
  const [qtListItem, setQtListItem] = useState(10);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [showProduct, setShowProduct] = useState([true, 0]);
  const [showExtras, setShowExtras] = useState(false);
  const [listReservation, setListReservation] = useState([]);
  const [deleteReservation, setDeleteReservation] = useState("");
  const [loadingItems, setLoadingItems] = useState([`listReservation`]);
  const isLoading = useMemo(() => loadingItems.length > 0, [loadingItems]);
  // Filter
  const [selectedProduct, setSelectedProduct] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [paymentFilter, setPaymentFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  // Pagination
  const [qtLimitItem, setQtLimitItem] = useState(10);
  const [pageItemsList, setPageItemsList] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [reservationAll, setReservationAll] = useState([]);
  const [viewReserve, setViewReserve] = useState("");
  const [addNew, setAddNew] = useState(false);
  const [loadBtn, setLoadBtn] = useState(false);
  const [error, setError] = useState(false);
  const { userEstablishment, isPetEstablishment, isFashionEstablishment, isFoodEstablishment } = useAuth();

  const isAddNewFoodDrawerOpen = addNew && isFoodEstablishment === true && openDrawer;
  const isAddNewPetDrawerOpen = addNew && isPetEstablishment === true && openDrawer;
  const isFoodDrawerOpen = openDrawer && isFoodEstablishment === true;
  const isPetDrawerOpen = isPetEstablishment && openDrawer;
  const isFashionDrawerOpen = openDrawer && isFashionEstablishment === true;

  //NewReservePet

  const reserveInitialPet = {
    _id: "",
    tel: "",
    client: "",
    userId: "",
    email: "",
    pickUp: false,
    address: "",
    serviceList: [{ products: "", qty: 1, date: "", hour: "", infoPet: "" }],
    totalValue: 0,
  };
  const reserveInitialFood = {
    _id: "",
    tel: "",
    client: "",
    userId: "",
    date: "",
    hour: "",
    email: "",
    qtyClients: 1,
    description: "",
  };
  const initialReserve = isPetEstablishment ? reserveInitialPet : isFoodEstablishment ? reserveInitialFood : {};
  const [reserve, setReserve] = useState(() => initialReserve);

  const { id } = useParams();
  const location = useLocation();

  const handleNewReserve = (event) => {
    setReserve((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  useEffect(() => {
    get();
    getAllReservations();
  }, [qtListItem, nameFilter, pageItemsList, selectedProduct, paymentFilter, statusFilter]);

  useEffect(() => {
    linkId(id);
  }, [id]);

  const linkId = async (id) => {
    if (id !== "todas") {
      setTimeout(async () => {
        const response = await api.get(`/clientReservation/${id}`);
        let object = { ...response.data, date: new Date(response.data?.date).toLocaleDateString("pt-br") };
        handleDrawerOpen(object);
        location.pathname = "todas";
      }, 500);
    }
  };

  const get = async () => {
    try {
      const establishment = await getUserEstablishment(localStorage.getItem("@Reservei:userId"));
      const list = await api
        .get(
          `/establishmentReservations?establishment=${establishment[0]._id}&paginate=true&page=${pageItemsList}&limit=${qtListItem}&name=${nameFilter}&payment=${paymentFilter}&status=${statusFilter}`
        )
        .then((res) => res.data.docs);
      setListReservation(
        list.map((reservation) => {
          let date = moment.utc(reservation.date).format("DD/MM/YYYY");
          return { ...reservation, date: date };
        })
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingItems(loadingItems.filter((e) => e !== "listReservation"));
    }
  };

  const getAllReservations = async () => {
    const userEstablishment = await getUserEstablishment(localStorage.getItem("@Reservei:userId"), nameFilter);
    let res = await getClientReservationsAllByEstablishment(userEstablishment[0]._id);
    setTotalItems(res.total);
    const deduplicatedReservationsByName = res.list.filter(
      (val, i, arr) => arr.findIndex((val2) => val2.user.name === val.user.name) === i
    );

    setReservationAll(deduplicatedReservationsByName);
  };

  const createPetReservation = async () => {
    setLoadBtn(true);
    if (isPetEstablishment) {
      if (!reserve.userId) {
        let user = {
          name: reserve.client,
          email: reserve.email,
          phone: reserve.tel.replace(/\s/g, ""),
          password: "123456",
        };
        try {
          const newUser = await api.post("/user", user).then((resp) => {
            console.log(resp);
            if (!resp.data.success) {
              setLoadBtn(false);
              return swal("Erro", `${resp.data.message}`, "error");
            }
            reserve.userId = resp.data.user._id;
            setError(false);
          });
        } catch (error) {
          console.log(error.message);
          setLoadBtn(false);
        }
      }
      for (let i = 0; i < reserve.serviceList.length; i++) {
        const reservation = reserve.serviceList[i];
        let object = {
          establishment: userEstablishment,
          user: reserve.userId,
          date: parseISO(reservation.date),
          time: reservation.hour,
          transport: reserve.pickUp,
          totalPrice: reservation.products.price,
          products: [
            {
              product: reservation.products._id,
              productName: reservation.products.name,
              qtyProduct: 1,
              description: reservation.infoPet,
              price: reservation.products.price,
            },
          ],
          transportPets: [{ address: reserve.pickUp ? reserve.address : "" }],
        };
        try {
          const response = await api.post("/clientReservation", object).then((resp) => {
            get();
            setOpenDrawer(false);
            setLoadBtn(false);
            setAddNew(false);
            setReserve(reserveInitialPet);
            setError(false);
            swal("Sucesso!", "Reserva efetuada com sucesso", "success");
          });
        } catch (error) {
          setError(false);
          setReserve(reserveInitialPet);
          setLoadBtn(false);
          setAddNew(false);
        }
      }
    }
  };
  const createFoodReservation = async () => {
    if (!reserve.client || !reserve.email || !reserve.tel || !reserve.hour || !reserve.date) return;
    setLoadBtn(true);
    if (isFoodEstablishment) {
      if (!reserve.userId) {
        let user = {
          name: reserve.client,
          email: reserve.email,
          phone: reserve.tel.replace(/\s/g, ""),
          password: "123456",
        };
        try {
          const newUser = await api.post("/user", user).then((resp) => {
            console.log(resp);
            if (!resp.data.success) {
              setLoadBtn(false);
              return swal("Erro", `${resp.data.message}`, "error");
            }
            reserve.userId = resp.data.user._id;
            setError(false);
          });
        } catch (error) {
          console.log(error.message);
          setLoadBtn(false);
        }
      }
      let object = {
        establishment: userEstablishment,
        user: reserve.userId,
        date: parseISO(reserve.date),
        time: reserve.hour,
        qtyClients: reserve.qty,
        description: reserve.description,
        status: "Confirmada",
      };
      try {
        const response = await api.post("/clientReservation", object).then((resp) => {
          swal("Sucesso!", "Reserva efetuada com sucesso", "success");
          get();
          setOpenDrawer(false);
          setLoadBtn(false);
          setAddNew(false);
          setReserve(reserveInitialFood);
          setError(false);
          console.log("aqui");
        });
      } catch (error) {
        setError(false);
        setReserve(reserveInitialFood);
        setLoadBtn(false);
        setAddNew(false);
      }
    }
  };

  const prevButton = () => {
    if (pageItemsList !== 1) {
      setPageItemsList(pageItemsList - 1);
    }
  };

  const nextButton = () => {
    let qtPages = Math.ceil(totalItems / qtLimitItem);
    if (pageItemsList.toString() !== qtPages.toString()) {
      setPageItemsList(pageItemsList + 1);
    }
  };

  const changePage = (event) => {
    setPageItemsList(event.target.id);
  };

  const handleEditPayment = async (id, payment) => {
    api.put(`/clientReservation/${id}`, { payment: payment });
    get();
  };

  const handleEditConfirmation = async (id, status) => {
    api.put(`/clientReservation/${id}`, { status: status });
    get();
  };

  const handleDeleteReservation = async () => {
    await api.put(`/deleteReservation/${deleteReservation}`).then(async (data) => {
      if (data.data.clientReservation.paymentIntent) {
        let object = {
          intent: data.data.clientReservation.paymentIntent,
          amount: data.data.clientReservation.totalPrice,
        };
        await api.post(`/cancel-payment`, object).then((resp) => {
          // console.log(resp);
        });
      }
    });
    get();
  };

  const handleDrawerOpen = (item) => {
    setOpenDrawer(true);
    setViewReserve(item);
  };
  const addButton = () => {
    setAddNew(true);
    setOpenDrawer(true);
    setViewReserve("");
    setReserve(initialReserve);
  };

  const handleChangeStatusReserve = (item, target) => {
    if (target === "Cancelada") {
      setDeleteReservation(item);
      document.getElementById("btnCallConfirmDelete").click();
      return;
    }
    handleEditConfirmation(item, target);
  };

  const exportTable = async () => {
    const response = await api
      .get(`/reserves-excel/?establishment=${userEstablishment}`, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "report.xlsx");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Layout defaultMenu={1} title={"Reservas"} link={""}>
        <div className="store container-fluid px-lg-1 pt-1">
          <div className="d-flex flex-column flex-lg-row justify-content-between">
            <div className="col-12 col-lg-3 mt-2 mb-3">
              <div className="input-group input-search">
                <input
                  onChange={({ target }) => setNameFilter(target.value)}
                  value={nameFilter}
                  type="text"
                  className="form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto "
                  placeholder="Buscar"
                />
                <span className="input-group-text bg-white border-0">
                  <i className="bi bi-search text-cl-auroMetal"></i>
                </span>
              </div>
            </div>
            <div className="d-flex">
              <div className={`col-12 justify-content-end col-lg d-flex mb-3 ms-lg-2`}>
                <BlackWhiteButton
                  onClick={() => exportTable()}
                  className=" py-2"
                  size={6}
                  sizeLg="auto"
                  text="Exportar planilha"
                />
                {!isFashionEstablishment ? (
                  <AddButton
                    onClick={() => addButton()}
                    size={"auto"}
                    className={"ms-4 py-2"}
                    text={" Adicionar reserva"}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex flex-column flex-lg-row pb-4">
            <List
              onChange={(e) => setQtListItem(e.target.value)}
              section="reservas"
              limit={qtListItem}
              totalItem={totalItems}
              page={pageItemsList}
              prevButton={() => prevButton()}
              nextButton={() => nextButton()}
              changePage={(e) => changePage(e)}
            >
              <ListHeader>
                <ListHeaderItem sizeLg={2} title={"Cliente"}>
                  <ListHeaderItemDropdown>
                    <li
                      className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                      style={{ borderBottom: "1px solid #D9D9D9" }}
                    >
                      <div className="input-group input-search">
                        <input
                          onChange={({ target }) => setNameFilter(target.value)}
                          value={nameFilter}
                          type="text"
                          style={{ width: "173px" }}
                          className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                          placeholder={"Procure por cliente"}
                        />
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search " style={{ color: "#000000" }}></i>
                        </span>
                      </div>
                    </li>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      {reservationAll
                        .filter((reservation) => reservation.user.name.toLowerCase().includes(nameFilter.toLowerCase()))
                        .map((item) => (
                          <div onClick={() => setNameFilter(item.user.name)} className="dropdown-item">
                            <span>{item.user.name}</span>
                          </div>
                        ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                <ListHeaderItem sizeLg={2} title={"Data"}></ListHeaderItem>
                <ListHeaderItem sizeLg={2} title={"Hora"}></ListHeaderItem>
                <ListHeaderItem sizeLg={3} title={"Status da reserva"}>
                  <ListHeaderItemDropdown>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      {[{ name: "Todos" }, { name: "Confirmada" }, { name: "Cancelada" }, { name: "Pendente" }].map(
                        (item) => (
                          <div
                            onClick={() => setStatusFilter(item.name === "Todos" ? "" : item.name)}
                            className="dropdown-item"
                          >
                            <span>{item.name}</span>
                          </div>
                        )
                      )}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                {/* <ListHeaderItem sizeLg={2} title={"Pagamento"}>
                  <ListHeaderItemDropdown>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      {[{ name: "Todos" }, { name: "Pago" }, { name: "Não pago" }].map((item) => (
                        <div
                          onClick={() =>
                            setPaymentFilter(item.name === "Pago" ? true : item.name === "Todos" ? "" : false)
                          }
                          className="dropdown-item"
                        >
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem> */}
                <ListHeaderItem sizeLg={2} title={"Valor"}></ListHeaderItem>
              </ListHeader>
              <ListBody>
                {isLoading ? (
                  <>
                    <div className="d-flex justify-content-center py-5 text-cl-auroMetal">
                      <Spinner
                        animation="border"
                        role="status"
                        style={{ height: "8rem", width: "8rem", borderWidth: "0.8em" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  </>
                ) : listReservation.length === 0 ? (
                  <EmptyListContent text={"Não existem reservas."} />
                ) : (
                  listReservation.map((item, index) =>
                    index + 1 <= qtListItem ? (
                      <ListBodyCell
                        hover={"cell-onhover c-pointer"}
                        key={index}
                        className={`cell-onhover ${index % 2 !== 0 ? "bg-cl-cultured" : ""}`}
                        onClick={() => handleDrawerOpen(item)}
                      >
                        <ListBodyItem
                          onClick={() => handleDrawerOpen(item)}
                          sizeLg={2}
                          description={"Cliente"}
                          title={item.user.name}
                        />
                        <ListBodyItem
                          onClick={() => handleDrawerOpen(item)}
                          sizeLg={2}
                          description="Data"
                          title={item.date}
                        />
                        <ListBodyItem
                          onClick={() => handleDrawerOpen(item)}
                          sizeLg={2}
                          description="Hora"
                          title={item.time}
                        />
                        <ListBodyItemSelect
                          onChange={({ target }) => handleChangeStatusReserve(item._id, target.value)}
                          disabled={item.status === "Cancelada" ? true : false}
                          sizeLg={3}
                          description="Status da reserva"
                          value={item.status}
                          className={`w-75 ${
                            item.status === "Confirmada"
                              ? "text-cl-forest-green"
                              : item.status === "Cancelada"
                              ? "text-cl-red"
                              : "text-cl-american-orange"
                          }`}
                        >
                          <option value="Confirmada" className="text-cl-auroMetal">
                            Confirmada
                          </option>
                          <option value="Cancelada" className="text-cl-auroMetal">
                            Cancelada
                          </option>
                          <option value="Pendente" className="text-cl-auroMetal">
                            Pendente
                          </option>
                        </ListBodyItemSelect>
                        {/* <ListBodyItemSelect
                        sizeLg={2}
                        description="Pagamento"
                        onChange={({ target }) =>
                          handleEditPayment(item._id, target.value === "confirmed" ? true : false)
                        }
                        value={item.payment ? "confirmed" : "pending"}
                        className={item.status === "confirmed" ? "text-cl-forest-green" : "text-cl-auroMetal"}
                      >
                        <option value="confirmed" className="text-cl-auroMetal">
                          Pago
                        </option>
                        <option value="pending" className="text-cl-auroMetal">
                          Não Pago
                        </option>
                      </ListBodyItemSelect> */}
                        <ListBodyItemNumberformat
                          onClick={() => handleDrawerOpen(item)}
                          sizeLg={2}
                          description="Valor"
                          value={item.totalPrice}
                        />
                        {/* <ListBodyItemAction sizeLg={1} title={"excluir"}>
                          <li className="py-2 px-2" onClick={() => setDeleteReservation(item._id)}>
                            <span
                              data-bs-toggle="modal"
                              data-bs-target="#confirmDeleteReservation"
                              className="dropdown-item fz-14 ff-univanova-regular text-prop-danger  c-pointer text-cl-red "
                            >
                              Cancelar
                            </span>
                          </li>
                        </ListBodyItemAction> */}
                      </ListBodyCell>
                    ) : (
                      <></>
                    )
                  )
                )}
              </ListBody>
            </List>
          </div>
        </div>
      </Layout>
      <button
        id="btnCallConfirmDelete"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#confirmDeleteReservation"
      >
        Chamar modal confirm delete
      </button>
      <ConfirmDelete
        id="confirmDeleteReservation"
        onClick={handleDeleteReservation}
        title={"Tem certeza que quer cancelar essa reserva?"}
        text={"Confirmar cancelamento"}
        subTitle={"Ao cancelar essa reserva, todo pagamento feito pelo cliente será desfeito."}
      />

      <ReservePetDrawer
        {...{
          openDrawer,
          setShowProduct,
          setOpenDrawer,
          viewReserve,
          showProduct,
          isPetDrawerOpen,
          showExtras,
          setShowExtras,
        }}
      />
      {/* <AddPetDrawer
        {...{
          openDrawer,
          setShowProduct,
          setOpenDrawer,
          viewReserve,
          showProduct,
          isPetDrawerOpen,
        }}
      /> */}
      <ReserveFoodDrawer
        {...{
          openDrawer,
          setShowProduct,
          showProduct,
          setOpenDrawer,
          isFoodDrawerOpen,
          viewReserve,
          showExtras,
          setShowExtras,
        }}
      />
      <ReserveFashionDrawer
        {...{
          openDrawer,
          setShowProduct,
          setOpenDrawer,
          showProduct,
          isFashionDrawerOpen,
          viewReserve,
          showExtras,
          setShowExtras,
        }}
      />
      {/* <ReservePetDrawer {...{ openDrawer, setShowProduct, setOpenDrawer, showProduct }} /> */}

      <NewReserveFoodDrawer
        {...{
          reserveInitialFood,
          createFoodReservation,
          reserve,
          loadBtn,
          handleNewReserve,
          isAddNewFoodDrawerOpen,
          setOpenDrawer,
          setAddNew,
        }}
      />
      <NewReservePetDrawer
        {...{
          initialReserve,
          loadBtn,
          createPetReservation,
          isAddNewPetDrawerOpen,
          setOpenDrawer,
          setAddNew,
          setShowProduct,
          showProduct,
          userEstablishment,
          reserve,
          setReserve,
          handleNewReserve,
        }}
      />
    </>
  );
}

export default Reserve;
